var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function TextColorIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.37102 11.5H14.629L12 6.25L9.37102 11.5ZM7.39443 15.4472C7.14744 15.9412 6.54676 16.1414 6.05279 15.8944C5.55881 15.6474 5.35858 15.0468 5.60557 14.5528L11.1056 3.55279C11.4741 2.81574 12.5259 2.81574 12.8944 3.55279L18.3944 14.5528C18.6414 15.0468 18.4412 15.6474 17.9472 15.8944C17.4532 16.1414 16.8526 15.9412 16.6056 15.4472L15.6305 13.5H8.36951L7.39443 15.4472ZM3 19.5C3 18.6716 3.67277 18 4.50371 18H19.4963C20.3268 18 21 18.6733 21 19.5C21 20.3284 20.3272 21 19.4963 21H4.50371C3.67323 21 3 20.3267 3 19.5Z", fill: "" })));
}
export var TextColorIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: TextColorIconInner }, props))); };
//# sourceMappingURL=TextColorIcon.js.map